import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface BackofficeAccessResponse {
  version: number;
  modules: Record<string, boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class BackofficeAccessService {
  modules = signal<Record<string, boolean>>({});
  accessLoaded = signal(false);
  private accessRequest?: Observable<BackofficeAccessResponse>;

  constructor(private http: HttpClient) {}

  loadAccess(): Observable<BackofficeAccessResponse> {
    if (!this.accessRequest) {
      this.accessRequest = this.http
        .get<BackofficeAccessResponse>(`${environment.apiUrl}/backoffice/me/access`)
        .pipe(
          tap((response) => {
            this.modules.set(response.modules ?? {});
            this.accessLoaded.set(true);
          }),
          // Keep the resolved response available for guards/components that
          // subscribe during the same navigation after login.
          shareReplay({ bufferSize: 1, refCount: false }),
        );
    }

    return this.accessRequest;
  }

  hasModule(moduleKey: string): boolean {
    return this.modules()[moduleKey] === true;
  }

  hasModuleKey(moduleKey: string): boolean {
    return moduleKey in this.modules();
  }

  clearAccess() {
    this.modules.set({});
    this.accessLoaded.set(false);
    this.accessRequest = undefined;
  }
}
